import type {
  MetaDataEtcDevice,
  MetaDataTagSceneType,
  MetaDataTagSolution,
  MetaDataTagWeather,
} from '@/type';

export const META_MANAGEMENT_SCENE_OPTION_LIST = [
  { i18nKey: 'metaManagement.scene.none', value: 'None' },
  { i18nKey: 'metaManagement.scene.alley', value: 'Alley' },
  { i18nKey: 'metaManagement.scene.highway', value: 'Highway' },
  { i18nKey: 'metaManagement.scene.indoor', value: 'Indoor' },
  { i18nKey: 'metaManagement.scene.intersection', value: 'Intersection' },
  { i18nKey: 'metaManagement.scene.office', value: 'Office' },
  { i18nKey: 'metaManagement.scene.plaza', value: 'Plaza' },
  { i18nKey: 'metaManagement.scene.simulation', value: 'Simulation' },
  { i18nKey: 'metaManagement.scene.square', value: 'Square' },
  { i18nKey: 'metaManagement.scene.urban', value: 'Urban' },
  { i18nKey: 'metaManagement.scene.parkingLot', value: 'Parking lot' },
  { i18nKey: 'metaManagement.scene.construction', value: 'Construction' },
  {
    i18nKey: 'metaManagement.scene.provingGround',
    value: 'Proving ground',
  },
] as const satisfies ReadonlyArray<{
  i18nKey: string;
  value: MetaDataTagSceneType;
}>;

export const META_MANAGEMENT_WEATHER_OPTION_LIST = [
  { i18nKey: 'metaManagement.weather.sunny', value: 'Sunny' },
  { i18nKey: 'metaManagement.weather.rain', value: 'Rain' },
  { i18nKey: 'metaManagement.weather.snow', value: 'Snow' },
  { i18nKey: 'metaManagement.weather.fog', value: 'Fog' },
  { i18nKey: 'metaManagement.weather.hardRain', value: 'Hard rain' },
  { i18nKey: 'metaManagement.weather.hardSnow', value: 'Hard snow' },
] as const satisfies ReadonlyArray<{
  i18nKey: string;
  value: MetaDataTagWeather;
}>;

export const META_MANAGEMENT_SOLUTION_OPTION_LIST = [
  { i18nKey: 'metaManagement.solution.vueOne', value: 'vueone' },
  { i18nKey: 'metaManagement.solution.vueTwo', value: 'vuetwo' },
] as const satisfies ReadonlyArray<{
  i18nKey: string;
  value: MetaDataTagSolution;
}>;

export const META_MANAGEMENT_ETC_DEVICE_OPTION_LIST = [
  { i18nKey: 'metaManagement.device.radar', value: 'Radar' },
  { i18nKey: 'metaManagement.device.gps', value: 'GPS' },
  { i18nKey: 'metaManagement.device.webcam', value: 'Webcam' },
  { i18nKey: 'metaManagement.device.ipcam', value: 'IPcam' },
] as const satisfies ReadonlyArray<{
  i18nKey: string;
  value: MetaDataEtcDevice;
}>;
